import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import api, { formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { Mail, Loader2 } from "lucide-react";

export function ChangeEmailDialog() {
  const { user, refresh } = useAuth();
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);

  const save = async () => {
    setBusy(true);
    try {
      await api.post("/auth/change-email", { new_email: email.trim() });
      await refresh();
      toast.success("Login email updated. Use it the next time you sign in.");
      setOpen(false);
      setEmail("");
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Couldn't update your email");
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="ghost" data-testid="change-email-button" className="w-full justify-start gap-2 text-muted-foreground hover:text-foreground">
          <Mail className="h-4 w-4" /> Change email
        </Button>
      </DialogTrigger>
      <DialogContent data-testid="change-email-dialog">
        <DialogHeader>
          <DialogTitle>Change login email</DialogTitle>
        </DialogHeader>
        <div className="space-y-3">
          <p className="text-sm text-muted-foreground">
            Current: <span className="font-mono text-foreground">{user?.email}</span>
          </p>
          <div>
            <Label className="mb-1.5 block font-mono text-[11px] uppercase tracking-wider text-muted-foreground">New email</Label>
            <Input type="email" data-testid="change-email-input" className="bg-secondary/40" value={email}
              onChange={(e) => setEmail(e.target.value)} placeholder="you@company.com" />
          </div>
          <p className="text-xs text-muted-foreground">You'll sign in with this address from now on. Your password and 2-step verification stay the same.</p>
        </div>
        <DialogFooter>
          <Button onClick={save} disabled={busy || !email.trim()} data-testid="change-email-save">
            {busy && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Save
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
